import styled from 'styled-components'

export const FooterContainer = styled.div`
  padding: 16px 16px 16px 24px;
  background-color: ${({ theme }) => theme.color.base.c0};
`
